import React, { ReactElement } from 'react';
import SuspenseLoadPage from '../components/Auth/SuspenceLoadPage';

const DashboardCom = React.lazy(() => import('../components/Dashboard'));

function Dashboard(): ReactElement {
  return (
    <SuspenseLoadPage>
      <DashboardCom />
    </SuspenseLoadPage>
  );
}

export default Dashboard;
